import { render, staticRenderFns } from "./AppBtn.vue?vue&type=template&id=1a614afd"
import script from "./AppBtn.vue?vue&type=script&lang=ts"
export * from "./AppBtn.vue?vue&type=script&lang=ts"
import style0 from "./AppBtn.vue?vue&type=style&index=0&id=1a614afd&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSpinner: require('/builds/project/wyffest/frontend/components/app/AppSpinner.vue').default})
